import styled from 'styled-components';

export const StyledLayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;

  @media ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
  }
`;

export const StyledMainContent = styled.main<{ $isCollapsed: boolean }>`
  flex: 1;
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
  padding: ${({ theme }) => theme.spacing.md};
  overflow-x: hidden;
  transition: margin-left 0.3s ease;

  @media ${({ theme }) => theme.media.desktop} {
    margin-left: ${({ $isCollapsed }) => ($isCollapsed ? '80px' : '240px')};
    padding: ${({ theme }) => theme.spacing.xl};
  }

  @media ${({ theme }) => theme.media.mobile} {
    margin-left: 0;
    min-height: auto;
    padding: ${({ theme }) => theme.spacing.md};
  }

  @media ${({ theme }) => theme.media.maxSm} {
    padding: ${({ theme }) => theme.spacing.sm};
  }
`;

export const StyledContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;
